module.exports = __webpack_public_path__ + "static/media/TRIDENT_CAROUSEL-1.48c5a321.jpg";